exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1NO6M3Xg7TRZ8_B24t-VYA{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._2Eqvr1m0f1ymjnY3Z2f_IX{height:100%;width:9.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlan_studentHorizontalSelect": "_1NO6M3Xg7TRZ8_B24t-VYA",
	"IndividualDevelopmentPlan_studentHorizontalSelect_option": "_2Eqvr1m0f1ymjnY3Z2f_IX"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/style.postcss
// module id = 1800
// module chunks = 0